import { useNavigate } from "react-router-dom";
import "./style.css";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  FormHelperText,
  FormLabel,
  Typography,
} from "@mui/material";
import CustomTextField from "../../Components/TextField";
import { useErrorHandler } from "../../hooks";
import logo from "../../Assets/Images/logo.png";
import ReactLoading from "react-loading";

import { useState, useRef, useEffect } from "react";
import {
  ResetPasswordAction,
  ForgetValidateOtpAction,
  ClearAuthResponse,
} from "../../Redux/Actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import HelmetReact from "../../Components/Helmet";

export const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, success } = useSelector((state) => state.Auth);

  const { setMsgConfig } = useErrorHandler();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup
        .string()
        .required("Please Enter email")
        .email()
        .matches(
          /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          "Please Enter valid email"
        ),
    }),
    onSubmit: (values) => {
      let payload = {
        email: formik.values.email,
      };
      dispatch(ForgetValidateOtpAction(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Password Change successfully!",
        severity: "success",
        autoHideDuration: 2000,
      });
    },
  });

  useEffect(() => {
    dispatch(ClearAuthResponse());
  }, []);
  return (
    <>
      <HelmetReact name="Forget-Password" />
      <Box className="forget-passwordForm">
        <Box className="form-contianer">
          <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box>
          <Typography className="lable forget-password-header" variant="h3">
            Forgot Password
          </Typography>

          
            <Box className="input forget-password-input">
              <FormLabel sx={{ display: "flex" }}>Email *</FormLabel>
              <CustomTextField
                margin="normal"
                fieldType="simpleTextInput"
                type="email"
                variant="standard"
                required
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder={"Enter your Email Addresss"}
                error={formik.touched.email && Boolean(formik.errors.email)}
              />

              {formik.touched.email && formik.errors.email && (
                <FormHelperText className="error_message">
                  {formik.errors.email}
                </FormHelperText>
              )}
            </Box>
      

          <Box className="form-custom-btn forget-password-button">
            <Button variant="contained" onClick={formik.handleSubmit}>
              {loading ? (
                <Box className="outer_loader">
                  <ReactLoading
                    type={"spinningBubbles"}
                    height="30px"
                    width="30px"
                    color="#FFFFFF"
                  />
                </Box>
              ) : (
                "SEND"
              )}
            </Button>
          </Box>
        
        </Box>
      </Box>
    </>
  );
};
